"use client";

import { useScroll, useTransform } from "motion/react";
import { useRef } from "react";

import { ScrollTextReveal } from "@/components/motion/scroll-text-reveal";

// =============================================================================

/** Share of the pinned scroll spent revealing the words */
const REVEAL_END = 0.85;

/**
 * The statement stays pinned in the middle of the screen while its words
 * light up one after another, then it holds a little before scrolling away.
 */
export function PinnedIntro({ text }: { text: string }) {
  const ref = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end end"],
  });
  // Function transform: no native scroll acceleration inside the sticky
  const progress = useTransform(scrollYProgress, (value) => value);

  return (
    <section ref={ref} className="relative h-[170svh]">
      <div className="sticky top-0 flex h-svh flex-col items-center justify-center">
        <div className="container-page">
          <ScrollTextReveal
            text={text}
            progress={progress}
            range={[0.02, REVEAL_END]}
            className="mx-auto max-w-[56rem] justify-center text-center text-[clamp(1.6rem,3.15vw,2.75rem)] leading-[1.2] font-normal tracking-[-0.01em]"
          />
        </div>
      </div>
    </section>
  );
}

// =============================================================================
